




















































































































































































































import { IUserSession } from '@/store/modules/session';
import { last } from 'lodash';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import Ellipsis from './components/Ellipsis.vue';
import SearchList from './components/SearchList.vue';
import { SearchAllParams } from './yqRequest';
import { datetime } from '@/utils/filter';
import { Moment } from 'moment';

enum SearchMode {
  模糊 = 1,
  精准 = 2,
}
enum TimeRange {
  当天 = 1,
  '24小时' = 2,
  '近7天' = 3,
  昨天 = 5,
  '近3天' = 6,
}

@Component({ components: { Ellipsis, SearchList } })
export default class Search extends Vue {
  @State(s => s.session.activeSession) currentSession: IUserSession;

  @Watch('params.typeList')
  valueChange() {
    this.checkAll = this.params.typeList.length === this.checkedOptions.length;
  }

  get SearchMode() {
    return SearchMode;
  }
  get TimeRange() {
    return TimeRange;
  }

  get getTimeRange() {
    let text = '';
    if (this.params.timeRange) {
      text = TimeRange[this.params.timeRange];
    } else {
      if (this.params.beginTime && this.params.endTime) {
        text =
          datetime(this.params.beginTime, 'YYYY-MM-DD HH:mm') + '-' + datetime(this.params.endTime, 'YYYY-MM-DD HH:mm');
      } else text = '自定义时间';
    }
    return text;
  }

  get getText() {
    // params.typeList.length == checkedOptions.length ? '全部' : params.typeList.join(',')
    let text = '';
    if (this.params.typeList.length == this.checkedOptions.length) {
      text = '全部';
    } else {
      const res = this.params.typeList.map(item => {
        const option = this.checkedOptions.find(opt => opt.value === item);
        return option?.label;
      });
      text = res.join(',');
    }
    return text;
  }

  showDate = false;

  checkAll = true;

  params: SearchAllParams = {
    excludeWord: '',
    keywords: '',
    searchMode: SearchMode.精准,
    timeRange: TimeRange['24小时'],
    typeList: [],
    beginTime: null,
    endTime: null,
    pageSize: 30,
    offset: 0,
  };

  timeRange = {
    beginTime: undefined as Moment | undefined,
    endTime: undefined as Moment | undefined,
  };

  disabledStartDate(startValue: Moment) {
    const endValue = this.timeRange.endTime;
    if (!startValue || !endValue) {
      return false;
    }
    return (
      startValue.valueOf() > endValue.valueOf() ||
      startValue.valueOf() <=
        endValue
          .clone()
          .subtract(31, 'days')
          .valueOf()
    );
  }

  disabledEndDate(endValue: Moment) {
    const startValue = this.timeRange.beginTime;
    if (!endValue || !startValue) {
      return false;
    }
    return (
      startValue.valueOf() >= endValue.valueOf() ||
      endValue.valueOf() >=
        startValue
          .clone()
          .add(31, 'days')
          .valueOf()
    );
  }

  isShowList = false;

  checkedOptions = [
    {
      label: '正文',
      value: 'content',
    },
    {
      label: '标题',
      value: 'title',
    },
    {
      label: '原文',
      value: 'comment',
    },
    {
      label: '作者',
      value: 'author',
    },
    {
      label: '来源',
      value: 'site',
    },
    {
      label: '签到地',
      value: 'post_place',
    },
    {
      label: '发布地',
      value: 'ip_region',
    },
  ];

  menuSelect(item: any) {
    this.params.searchMode = item.key;
  }

  onCheckAllChange(e: any) {
    this.checkAll = e.target.checked;
    this.params.typeList = e.target.checked ? this.checkedOptions.map(item => item.value) : [];
  }

  timeSelect(e: any) {
    this.params.timeRange = e.key;
    if (!e.key) {
      e.domEvent.stopPropagation();
      this.showDate = true;
    } else this.showDate = false;
  }

  customTime() {
    this.params.timeRange = null;
    this.showDate = true;
  }

  visibleChange(visible: boolean) {
    if (visible === false) {
      if (this.checkAll == false && this.params.typeList.length === 0)
        this.params.typeList = this.checkedOptions.map(item => item.value);
    }
  }

  onSearch(e: any) {
    if (!this.params.keywords) {
      this.$message.warning('请输入关键词');
      return;
    }

    if (!this.params.timeRange && !this.timeRange.beginTime && !this.timeRange.endTime) {
      this.$message.warning('请选择时间范围');
      return;
    }
    this.isShowList = true;
    this.params.beginTime = this.timeRange.beginTime
      ? new Date(this.timeRange.beginTime.toLocaleString()).getTime()
      : null;
    this.params.endTime = this.timeRange.endTime ? new Date(this.timeRange.endTime.toLocaleString()).getTime() : null;

    this.$nextTick(() => {
      this.$refs.searchListRef && (this.$refs.searchListRef as SearchList).onSearch();
    });
  }

  mounted() {
    this.params.typeList = this.checkedOptions.map(item => item.value);
  }
}
